const states = {
    1: { text: "Pendiente", color: "grey", pastelHexColor: "#e0e0e0", icon: "mdi-clock-outline" },
    2: { text: "Presentada", color: "blue", pastelHexColor: "#90caf9", icon: "mdi-file-document-check-outline" },
    6: { text: "Activada Parcial", color: "light-green", pastelHexColor: "#c5e1a5", icon: "mdi-file-document-remove" },
    4: { text: "Activada", color: "green", pastelHexColor: "#a5d6a7", icon: "mdi-check" },
    5: { text: "Error envío a SMART", color: "yellow", pastelHexColor: "#fff59d", icon: "mdi-alert" },
    3: { text: "Rechazada", color: "red", pastelHexColor: "#ef9a9a", icon: "mdi-file-document-remove" },
    7: { text: "Cancelada", color: "orange", pastelHexColor: "#ffcc80", icon: "mdi-cancel" },
};

export default states;  